import React from 'react';
import { Box } from '@mui/material';
import { ContainerProps, DndProps } from '../types';

export const Container = React.memo(
  ({ ref, render, handleProps, isHover, ...props }: ContainerProps) => {
    return (
      <Box
        {...props}
        ref={ref}
        sx={{
          maxWidth: 1,
          flex: '0 0 100%',
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {render?.({
            ...handleProps,
          } as DndProps)}
        </Box>
      </Box>
    );
  },
);
